import { render, staticRenderFns } from "./CommunicationTypeNote.vue?vue&type=template&id=3e5fb4df"
import script from "./CommunicationTypeNote.vue?vue&type=script&lang=ts"
export * from "./CommunicationTypeNote.vue?vue&type=script&lang=ts"
import style0 from "./CommunicationTypeNote.vue?vue&type=style&index=0&id=3e5fb4df&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports